import AdviserDetails from '@master/model/kyc-form/AdviserDetails'
import Validation from '@core/logic/Validation'

export default class AdviserDetailsValidation extends Validation {
  validate (adviserDetails: AdviserDetails, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, REQUIRE_ARRAY, WHEN } = this.validator()
    ADD(REQUIRE_ARRAY(adviserDetails.importantNoticeList, 'Adviser must be able to advise clients on a list of specific items'), ['Important Notices'], ['importantNoticeList'])
    ADD(WHEN(adviserDetails.importantNoticeList.includes('others'), REQUIRE(adviserDetails.importantNoticeOthers, 'Adviser must need to specify what to advise when others are selected.')), ['Important Notices'], ['importantNoticeOthers'])
    return getMessages()
  }
}
